import { FilterIcon } from './FilterIcon';

/**
 * author: Austin Andrews
 * id 39CAC4E6-CC95-42C8-94E9-E29089F1E91E
 * name filter
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter.svg
 * tags
 */
export const FunnelIcon = FilterIcon;
export default FunnelIcon